__turbopack_context__.v({
  "below": "LCatalogSingleColumn-module__SdbZPG__below",
  "content": "LCatalogSingleColumn-module__SdbZPG__content",
  "root": "LCatalogSingleColumn-module__SdbZPG__root",
});
